import React, { useContext, useMemo } from "react";
import { useAuth } from "./AuthContext";
import { useCustomerWorkspace } from "./CustomerWorkspaceContext";
import { useConnectionHealth } from "../hooks/useConnectionHealth";
import { ConnectionHealthContext, ConnectionHealthValue } from "./connectionHealthValue";

/**
 * One poll for the whole app. The alarm bell renders in two places (sidebar +
 * mobile header); without this each would run its own 5-minute poll. Mount once,
 * inside the auth + customer-workspace providers.
 */
export const ConnectionHealthProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { isAuthenticated } = useAuth();
  const { selectedCustomerId } = useCustomerWorkspace();
  const { alerts, redCount, amberCount, refetch } = useConnectionHealth({
    isAuthenticated,
    customerId: selectedCustomerId,
  });
  const value = useMemo(
    () => ({ alerts, redCount, amberCount, refetch }),
    [alerts, redCount, amberCount, refetch]
  );
  return (
    <ConnectionHealthContext.Provider value={value}>
      {children}
    </ConnectionHealthContext.Provider>
  );
};

export const useConnectionHealthContext = (): ConnectionHealthValue => {
  const value = useContext(ConnectionHealthContext);
  if (!value) {
    throw new Error(
      "useConnectionHealthContext must be used within a ConnectionHealthProvider"
    );
  }
  return value;
};
